import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from "react";
import { DebouncedSearch } from "../../Forms/DebouncedSearch";
import { DEFAULT_PARKS_SORT, useOutsideClick, usePaginationQuery } from "../../../utils";
import { useParks } from "../../Parks/hooks";
import { Button, CloseIcon, Typography } from "@parkschannel/ui";
import { AdvancedFilters } from "./AdvancedFilters/AdvancedFilters";
import { queryTypes, useQueryStates } from "next-usequerystate";
export const ParksFilters = (param)=>{
    let { children , pagination , queryParams  } = param;
    const [isOpen, setIsOpen] = useState(false);
    const { useParksQuery  } = useParks();
    const handleClose = ()=>{
        setIsOpen(false);
    };
    const dropdownRef = useRef(null);
    useOutsideClick(dropdownRef, handleClose);
    var _tags, _states;
    const [advancedFilters, setAdvancedFilters] = useQueryStates({
        tags: queryTypes.array(queryTypes.string).withDefault((_tags = queryParams.tags) !== null && _tags !== void 0 ? _tags : []),
        states: queryTypes.array(queryTypes.string).withDefault((_states = queryParams.states) !== null && _states !== void 0 ? _states : []),
        sortBy: queryTypes.string.withDefault(DEFAULT_PARKS_SORT)
    });
    const filteredTags = advancedFilters.tags.filter((tag)=>!!tag);
    const filteredStates = advancedFilters.states.filter((state)=>!!state);
    const filtersCount = filteredTags.length + filteredStates.length;
    const { data: parks , pagination: queryPagination  } = usePaginationQuery((paginationParams)=>useParksQuery(paginationParams, {
            ...queryParams,
            states: filteredStates,
            tags: filteredTags
        }, {
            keepPreviousData: true
        }), {
        initialPagination: pagination
    });
    const onSearch = async (search)=>{
        queryPagination.changeSearch(search);
        scrollTo();
    };
    const toggle = ()=>{
        setIsOpen((prev)=>!prev);
    };
    const onFilter = async (tags, states, sortBy)=>{
        var ref;
        await setAdvancedFilters({
            tags,
            states,
            sortBy
        });
        (ref = queryPagination.goToFirst) === null || ref === void 0 ? void 0 : ref.call(queryPagination);
        handleClose();
    };
    if (!parks || !parks.data) return null;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                ref: dropdownRef,
                className: "relative flex gap-1 justify-between items-center",
                children: [
                    /*#__PURE__*/ _jsx(DebouncedSearch, {
                        value: queryPagination.currentSearch,
                        onChange: onSearch,
                        placeholder: "Find a park"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "base",
                        className: "!px-3 !h-9 !min-w-[75px] !min-h-[38px] flex justify-center items-center !border-solid !border-[1px] !border-neutral-200",
                        onClick: toggle,
                        children: isOpen ? /*#__PURE__*/ _jsxs("div", {
                            className: "flex gap-2 items-center",
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "bodyBase",
                                    className: "font-bold text-neutral-500",
                                    children: "Close"
                                }),
                                /*#__PURE__*/ _jsx(CloseIcon, {
                                    className: "w-3 h-3",
                                    strokeWidth: 1
                                })
                            ]
                        }) : /*#__PURE__*/ _jsxs(Typography, {
                            variant: "bodyBase",
                            className: "font-bold text-neutral-500",
                            children: [
                                "Filter ",
                                filtersCount ? "(".concat(filtersCount, ")") : null
                            ]
                        })
                    }),
                    isOpen && /*#__PURE__*/ _jsx("div", {
                        className: "absolute z-10 top-[110%] right-0 w-full max-w-[450px] md:max-w-[320px]",
                        children: /*#__PURE__*/ _jsx(AdvancedFilters, {
                            initialSortBy: advancedFilters.sortBy,
                            initialStates: filteredStates,
                            initialTags: filteredTags,
                            onCancel: handleClose,
                            onFilter: onFilter
                        })
                    })
                ]
            }),
            children === null || children === void 0 ? void 0 : children({
                pagination: queryPagination,
                data: parks === null || parks === void 0 ? void 0 : parks.data
            })
        ]
    });
};
